import { Host, h } from '@stencil/core';
export class AibaQuizSingleScreen {
  constructor() {
    this.getData = undefined;
    this.handlers = undefined;
    this.data = undefined;
    this.quiz = undefined;
    this.classes = undefined;
    this.styles = undefined;
    this.quizIndex = undefined;
    this.singleScreen = false;
    this.quizData = false;
    this.selectedOptionsWithId = undefined;
    this.quizPlainIndex = undefined;
    this.totalGroupsLength = undefined;
    this.groupIndex = undefined;
    this.selectedOptions = undefined;
    this.totalQuestions = undefined;
    this.renderLeftHalf = undefined;
    this.enableNextButtonDisabled = undefined;
    this.enableMutlipleGroups = false;
    this.reRender = false;
  }
  handleTrigger() {
    this.reRender = !this.reRender;
  }
  async componentWillRender() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (this.handlers && this.handlers.handleQuizScreenOnLoad) {
      const { selectedOptions, selectedOptionsWithId = {}, data = {}, totalQuestions, currentQuizIndex, renderLeftHalf, quizPlainIndex, totalGroupsLength, groupIndex, enableNextButtonDisabled, enableMutlipleGroups, currentIntroIndex, } = await this.handlers.handleQuizScreenOnLoad({
        event: {},
        data: this.data,
      });
      if (data && Object.keys(data).length > 0) {
        this.data = data;
      }
      this.selectedOptionsWithId = selectedOptionsWithId ? selectedOptionsWithId : {};
      this.selectedOptions = selectedOptions ? selectedOptions : [];
      this.quizIndex = currentQuizIndex !== null && currentQuizIndex !== void 0 ? currentQuizIndex : 0;
      this.totalQuestions = totalQuestions !== null && totalQuestions !== void 0 ? totalQuestions : 0;
      this.renderLeftHalf = renderLeftHalf !== null && renderLeftHalf !== void 0 ? renderLeftHalf : false;
      this.quizPlainIndex = quizPlainIndex !== null && quizPlainIndex !== void 0 ? quizPlainIndex : 0;
      this.totalGroupsLength = totalGroupsLength !== null && totalGroupsLength !== void 0 ? totalGroupsLength : 0;
      this.groupIndex = groupIndex !== null && groupIndex !== void 0 ? groupIndex : 0;
      this.enableNextButtonDisabled = enableNextButtonDisabled !== null && enableNextButtonDisabled !== void 0 ? enableNextButtonDisabled : false;
      this.enableMutlipleGroups = enableMutlipleGroups !== null && enableMutlipleGroups !== void 0 ? enableMutlipleGroups : false;
      if (this.enableMutlipleGroups) {
        this.quizData = (_b = (_a = this.data[currentIntroIndex].data) === null || _a === void 0 ? void 0 : _a.quiz) === null || _b === void 0 ? void 0 : _b.data;
        this.singleScreen = (_e = (_d = (_c = this.data[currentIntroIndex].data) === null || _c === void 0 ? void 0 : _c.quiz) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.singleScreen;
      }
      else {
        this.quizData = (_g = (_f = this.data[0].data) === null || _f === void 0 ? void 0 : _f.quiz) === null || _g === void 0 ? void 0 : _g.data;
        this.singleScreen = ((_k = (_j = (_h = this.data[0].data) === null || _h === void 0 ? void 0 : _h.quiz) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.singleScreen) ? (_o = (_m = (_l = this.data[0].data) === null || _l === void 0 ? void 0 : _l.quiz) === null || _m === void 0 ? void 0 : _m.data) === null || _o === void 0 ? void 0 : _o.singleScreen : false;
      }
    }
  }
  async componentWillLoad() {
    var _a;
    if (this.getData) {
      const mainData = await this.getData();
      this.data = mainData === null || mainData === void 0 ? void 0 : mainData.data;
      this.classes = mainData === null || mainData === void 0 ? void 0 : mainData.classes;
      this.styles = mainData === null || mainData === void 0 ? void 0 : mainData.styles;
    }
    ((_a = this === null || this === void 0 ? void 0 : this.handlers) === null || _a === void 0 ? void 0 : _a.handleQuizScreenWillLoad) && this.handlers.handleQuizScreenWillLoad();
  }
  componentDidLoad() {
    var _a, _b;
    this.handlers && ((_a = this === null || this === void 0 ? void 0 : this.handlers) === null || _a === void 0 ? void 0 : _a.quizDidLoadhandler) && ((_b = this === null || this === void 0 ? void 0 : this.handlers) === null || _b === void 0 ? void 0 : _b.quizDidLoadhandler());
  }
  componentDidRender() {
    this.handlers && this.handlers.handleQuizScreenDidRender && this.handlers.handleQuizScreenDidRender();
  }
  render() {
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: "quiz-screen-grid-container" }, this.singleScreen && (h("aiba-quiz-multiple", {
      //each group will always have 1 ques atleast
      key: this.quizData.questions[0].data.groupId ? this.quizData.questions[0].data.groupId : 'userPI', data: Object.assign({}, this.quizData), selectedOptions: this.selectedOptions, selectedOptionsWithId: this.selectedOptionsWithId, handlers: this.handlers, totalQuestions: this.totalQuestions, quizPlainIndex: this.quizPlainIndex + 1, renderLeftHalf: this.renderLeftHalf, index: this.quizIndex, totalGroups: this.totalGroupsLength, groupIndex: this.groupIndex + 1, enableNextButtonDisabled: this.enableNextButtonDisabled, enableMutlipleGroups: this.enableMutlipleGroups
    })))));
  }
  static get is() { return "aiba-quiz-single-screen"; }
  static get properties() {
    return {
      "getData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "get-data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "data": {},
      "quiz": {},
      "classes": {},
      "styles": {},
      "quizIndex": {},
      "singleScreen": {},
      "quizData": {},
      "selectedOptionsWithId": {},
      "quizPlainIndex": {},
      "totalGroupsLength": {},
      "groupIndex": {},
      "selectedOptions": {},
      "totalQuestions": {},
      "renderLeftHalf": {},
      "enableNextButtonDisabled": {},
      "enableMutlipleGroups": {},
      "reRender": {}
    };
  }
  static get listeners() {
    return [{
        "name": "event-quizscreen",
        "method": "handleTrigger",
        "target": "window",
        "capture": true,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-quiz-single-screen.js.map
